import React, { ChangeEvent } from 'react';

import { Input } from './InputField.style';
import { SignUpBottomTextInput } from '../../styledComponent/Text.style';
import { InputColorVariant, InputProps } from './InputField.types';

export const InputField = ({
  error,
  name,
  type,
  placeholder,
  handleChange,
  value,
  bottomText,
  maxLength,
  id,
  disabled,
  className,
  success,
  colorVariant = InputColorVariant.White,
}: InputProps) => {
  return (
    <div>
      <Input
        id={id}
        className={className}
        type={type}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(event: ChangeEvent<HTMLInputElement>) => handleChange(event)}
        value={value}
        maxLength={maxLength}
        success={success}
        error={Boolean(error)}
        variant={colorVariant}
      />
      {bottomText ? <SignUpBottomTextInput>{bottomText}</SignUpBottomTextInput> : null}
    </div>
  );
};
